import { render, staticRenderFns } from "./ProfilPpb.vue?vue&type=template&id=30e802af"
import script from "./ProfilPpb.vue?vue&type=script&lang=js"
export * from "./ProfilPpb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports